import { render, staticRenderFns } from "./AdminResetPasswordRequest.vue?vue&type=template&id=22ea228f"
import script from "./AdminResetPasswordRequest.vue?vue&type=script&lang=ts"
export * from "./AdminResetPasswordRequest.vue?vue&type=script&lang=ts"
import style0 from "./AdminResetPasswordRequest.vue?vue&type=style&index=0&id=22ea228f&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports